import { IS_USE_PLEX_API } from '../../../constants';
import { CasinoTypeUnion } from '../../../types';
import { useGamesStore } from '../../store';
import { SingleCasinoLobbyPlexType, SingleFeedType } from '../../types';

export function useGamesFeed(feedName: string): SingleFeedType;
export function useGamesFeed(
  feedName: string,
  casinoType: CasinoTypeUnion
): SingleCasinoLobbyPlexType;

export function useGamesFeed(feedName: string, casinoType?: CasinoTypeUnion) {
  return useGamesStore((store) =>
    IS_USE_PLEX_API && casinoType
      ? store.lobbies[casinoType]
      : store.feeds[feedName]
  );
}
